// "Complete your collection" cross-sell quick add (cart drawer + cart page).
// Lives in an asset (not inline in cart-summary.liquid) because the drawer is
// re-rendered via section morphing — scripts inside injected section HTML never
// execute, so a fresh-cart session would get buttons with no handler.
(function () {
  if (window.__tbpCrossSellBound) return;
  window.__tbpCrossSellBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target instanceof Element ? e.target.closest('.tbp-cart-cross__card') : null;
    if (!btn || btn.disabled) return;
    var vid = btn.dataset.variantId;
    if (!vid) return;
    var addEl = btn.querySelector('.tbp-cart-cross__add');
    if (addEl) addEl.textContent = '...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(function (cartData) {
        if (addEl) addEl.textContent = String.fromCharCode(10003) + ' Added';
        btn.style.opacity = '0.5';

        // Dispatch the theme native cart:update event — triggers CartItemsComponent to re-render
        var evt = new Event('cart:update', { bubbles: true });
        evt.detail = { resource: cartData, data: {} };
        document.dispatchEvent(evt);

        // Update cart count bubble in header
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
      })
      .catch(function () {
        if (addEl) addEl.textContent = 'Error';
        btn.disabled = false;
        btn.style.opacity = '1';
      });
  });
})();
